/**
 * @desc pms-如果是新品下单判断是否存在供应商下单比例
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.RpcCheckWhetherExistsSettlementDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/checkWhetherExistsSettlement`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
